module.exports = __webpack_public_path__ + "images/accents/accent-peek-preview@1x-d5c65dd33da61e16b8a603c0c88ab87a.webp";